import React, { useState } from "react";
import "../Assets/Css/login.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Swal from "sweetalert2";
import { useAuth } from "../AuthProvider";

function Login() {
  const [phone, setPhone] = useState();
  const [password, setPassword] = useState();
  const [showPassword, setShowPassword] = useState(false);

  const auth = useAuth();


  // const loginUser = async () => {
  //     return axios
  //       .post(
  //         "https://app.dogdriveapp.com/api/v2/auth/authenticate",
  //         {
  //           phoneNumber: credentials.phone,
  //           password: credentials.password,
  //         },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
  //           },
  //         }
  //       )
  //       .then((data) => {
  //         return data.data;
  //       })
  //       .catch(function (error) {
  //         Swal.fire({
  //           icon: "error",
  //           title: "error",
  //           text: error.response.data.title,
  //         });
  //       });
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!phone || !password) {
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: "Please enter your phone number and password.",
      });
      return;
    }

    await auth.loginAction({
      phoneNumber: phone,
      password: password,
    });
  };


  return (
    <>
      <div className="login">
        <div className="login-card">
          <h1>Login</h1>
          <form onSubmit={handleSubmit}>
            <div className="form-group mb-3" >
              <input
                className="form-control"
                id="phone"
                name="phone"
                type="number"
                placeholder="Phone Number"
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>

            <div className="form-group mb-3">
              <div className="password-field">
                <input
                  className="form-control"
                  id="Password"
                  name="Password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>
            <button className="submit" type="submit">
              Submit
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default Login;
